export const parseTime = (
  time?: object | string | number | null,
  cFormat?: string
): string | null => {
  if (time === undefined || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date: Date
  if (typeof time === 'object') {
    date = time as Date
  } else {
    if (typeof time === 'string') {
      if (/^[0-9]+$/.test(time)) {
        time = parseInt(time)
      } else {
        time = time.replace(/-/gm, '/')
      }
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj: { [key: string]: number } = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return timeStr
}

export const formatJson = (filterKeys: any, jsonData: any) =>
  jsonData.map((data: any) => filterKeys.map((key: string) => {
    if (key === 'timestamp') {
      return parseTime(data[key])
    } else {
      return data[key]
    }
  }))

export const hasClass = (ele: HTMLElement, className: string) => {
  return !!ele.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'))
}

export const addClass = (ele: HTMLElement, className: string) => {
  if (!hasClass(ele, className)) ele.className += ' ' + className
}

export const removeClass = (ele: HTMLElement, className: string) => {
  if (hasClass(ele, className)) {
    const reg = new RegExp('(\\s|^)' + className + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

export const toggleClass = (ele: HTMLElement, className: string) => {
  if (!ele || !className) {
    return
  }
  let classString = ele.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  ele.className = classString
}
/**
 * 单位转换
 */
export function toThousandFilter(num:number) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}
// 获取当前时间
export function getNowTime() {
  let t = setTimeout(time, 1000)
  function time() {
    clearTimeout(t)// 清除定时器
    const dt:Date = new Date()
    const years:number = dt.getFullYear()
    const mt = (dt.getMonth() + 1) > 9 ? (dt.getMonth() + 1) : '0' + (dt.getMonth() + 1)
    const day = dt.getDate() > 9 ? dt.getDate() : '0' + dt.getDate()
    const h = dt.getHours() > 9 ? dt.getHours() : '0' + dt.getHours()// 获取时
    const m = dt.getMinutes() > 9 ? dt.getMinutes() : '0' + dt.getMinutes()// 获取分
    const s:string = dt.getSeconds() > 9 ? String(dt.getSeconds()) : '0' + dt.getSeconds(); // 获取秒
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    (document as Document).getElementById('showTime').innerHTML = `${years}年${mt}月${day}日${h}:${m}:${s}`
    t = setTimeout(time, 1000) // 设定定时器，循环运行
  }
}
export function getNowFormatDate() {
  let date = new Date(),
    year = date.getFullYear(), //获取完整的年份(4位)
    month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
    strDate = date.getDate() // 获取当前日(1-31)
  const monthText = month < 10 ? `0${month}` : month // 如果月份是个位数，在前面补0
  const strDateText = strDate < 10 ? `0${strDate}` : strDate // 如果月份是个位数，在前面补0
  return `${year}-${monthText}-${strDate}`
}

export function dateDiff(sDate1, sDate2) {  //sDate1和sDate2是yyyy-MM-dd格式
  let aDate, oDate1, oDate2, iDays;
  aDate = sDate1.split("-");
  oDate1 = new Date(aDate[1] + '/' + aDate[2] + '/' + aDate[0]);  //转换为yyyy-MM-dd格式
  aDate = sDate2.split("-");
  oDate2 = new Date(aDate[1] + '/' + aDate[2] + '/' + aDate[0]);
  iDays = Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24; //把相差的毫秒数转换为天数
  return parseInt(iDays);  //返回相差天数
}


// 获取月份并对获取为0时做12月份的转换
export function getMonthFilter(num:number) {
  const month = new Date().getMonth() + num
  const Y = month > 0 ? new Date().getFullYear() : new Date().getFullYear() - 1
  const M = month > 0 ? month : 13 + num
  return `${Y}年${M}月`
}
